import type { PhysicalStore } from '../domain/models/PhysicalStore';

function isCityToStoresMap(value: unknown): value is Record<string, PhysicalStore[]> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

export function getCityList(cityToStoresMap: unknown): string[] {
  if (!isCityToStoresMap(cityToStoresMap)) return [];
  return Object.keys(cityToStoresMap).filter(Boolean);
}

export function getStoreList(cityToStoresMap: unknown, cityKey: string): PhysicalStore[] {
  if (!cityKey || !isCityToStoresMap(cityToStoresMap)) return [];
  const raw = cityToStoresMap[cityKey];
  if (!Array.isArray(raw)) return [];
  return raw;
}

export function findCityKey(
  cityToStoresMap: unknown,
  candidate: string | undefined
): string | undefined {
  if (!candidate) return undefined;
  const list = getCityList(cityToStoresMap);
  if (list.length === 0) return undefined;
  const cand = candidate.trim();
  if (!cand) return undefined;
  const candSlug = toKebabCase(cand);
  return (
    list.find((c) => toKebabCase(c) === candSlug) ??
    list.find((c) => c.toLowerCase() === cand.toLowerCase())
  );
}

export function toKebabCase(value: string): string {
  return value
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-zA-Z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .toLowerCase();
}

export function titleFromSlug(value: string): string {
  const cleaned = value.trim().replace(/^\/+|\/+$/g, '');
  if (!cleaned) return '';
  return cleaned
    .split('-')
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
}

export function getStoreDisplayName(storeName: string): string {
  return storeName.trim().split(',')[0]?.trim() || storeName.trim();
}
